import { StatusCardType } from '@/home/OrderStatusCard/feedItemMapper';
import { FeedItemType } from '~/constants/home';

export function getCustomAttributesDescription(
  cardStatus: StatusCardType
): string {
  switch (cardStatus) {
    case StatusCardType.Order:
      return 'Order placed cta';
    case StatusCardType.Purchased:
      return 'Purchased vehicle cta';
    case StatusCardType.Reserved:
      return 'Reserved vehicle cta';
    case StatusCardType.PurchaseInProgress:
      return 'Purchase in progress cta';
  }
}

export function getTitleText(
  cardStatus: StatusCardType,
  make: string,
  hasOpenVerifications: boolean
): string {
  switch (cardStatus) {
    case StatusCardType.Order:
      return hasOpenVerifications
        ? "You're almost there!"
        : `Congrats on your new ${make}!`;
    case StatusCardType.Purchased:
      return `Congrats on your new ${make}!`;
    case StatusCardType.Reserved:
      return `This ${make} is reserved just for you!`;
    case StatusCardType.PurchaseInProgress:
      return `This ${make} is almost yours!`;
  }
}

export function getSubText(
  cardStatus: StatusCardType,
  hasOpenVerifications: boolean,
  feedType: string
): string {
  switch (cardStatus) {
    case StatusCardType.Order:
      return hasOpenVerifications
        ? ''
        : 'All of your tasks are complete! Sit back, relax and get excited for your new ride.';
    case StatusCardType.Purchased:
      return 'Everything for your car, all in one place. View your registration status, report an issue and more.';
    case StatusCardType.Reserved:
      return "We'll soon be inspecting and perfecting your new ride.";
    case StatusCardType.PurchaseInProgress:
      return feedType === FeedItemType.TRADE_PURCHASE_IN_PROGRESS
        ? 'You have a few more steps to complete your trade-in before time runs out!'
        : 'You have a few more steps to complete your purchase before time runs out!';
  }
}
